import { render, staticRenderFns } from "./match-type-list.vue?vue&type=template&id=f081cfae&scoped=true&"
import script from "./match-type-list.vue?vue&type=script&lang=js&"
export * from "./match-type-list.vue?vue&type=script&lang=js&"
import style0 from "./match-type-list.vue?vue&type=style&index=0&id=f081cfae&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f081cfae",
  null
  
)

component.options.__file = "match-type-list.vue"
export default component.exports